import ImageLightbox from './ImageLightbox';
import VideoLightbox from './VideoLightbox';

const lightboxes = {
	// Query selectors for image and video links.
	imageQuery: 'a[href*=".jpg"],a[href*=".gif"],a[href*=".png"],a[href*=".svg"]',
	videoQuery: '[href*="youtube.com"],[href*="youtu.be"],[href*="vimeo.com"],[href*="wistia.com"],[href*=".mp4"],[href*=".ogg"],[href*=".webm"]',
	// Placeholder arrays for lightbox instances.
	imageLightboxes: [],
	videoLightboxes: [],

	init() {
		this.initImageLightboxes();
		this.initVideoLightboxes();

		// Observe for changes after initial page load to avoid performance hit
		// when script tags are adding new elements all over the place.
		this.observe = this.observe.bind(this);
		window.addEventListener('load', this.observe);
	},

	initImageLightboxes() {
		const imageLinks = [...document.querySelectorAll(this.imageQuery)];
		if (imageLinks.length) {
			this.imageLightboxes = imageLinks.map((imageLink) => new ImageLightbox(imageLink));
		}
	},

	initVideoLightboxes() {
		const videoLinks = [...document.querySelectorAll(this.videoQuery)];
		if (videoLinks.length) {
			this.videoLightboxes = videoLinks.map((videoLink) => new VideoLightbox(videoLink));
		}
	},

	observe() {
		// Select the node that will be observed for mutations
		const targetNode = document.querySelector('.site');
		// Options for the observer (which mutations to observe)
		const config = { childList: true, subtree: true };
		// Callback function to execute when mutations are observed
		const callback = (mutationsList) => {
			mutationsList.forEach((mutation) => {
				const { addedNodes } = mutation;
				if (addedNodes.length) {
					addedNodes.forEach((node) => {
						if (node.querySelectorAll && typeof node.querySelectorAll === 'function') {
							const anchors = node.querySelectorAll('a');
							if (anchors.length) {
								anchors.forEach((anchor) => {
									if (anchor.matches(this.imageQuery)) {
										this.imageLightboxes.push(new ImageLightbox(anchor));
									} else if (anchor.matches(this.videoQuery)) {
										this.videoLightboxes.push(new VideoLightbox(anchor));
									}
								});
							}
						}
					});
				}
			});
		};

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver(callback);
		// Start observing the target node for configured mutations
		observer.observe(targetNode, config);
	},
};

window.addEventListener('load', () => {
	lightboxes.init();
});
